<div class="wrap-l wrap-x flex flex-justify-center">
    <div class="w-10">

        <!-- Section title -->
        <div class="w-6 w-12-m w-12-s p-b-4-m p-b-8-s p-b-8-m">
            <div class="w-9 w-7-m w-12-s text"
                 *iCms="'faq_title' of component; content: 'html'"></div>
        </div>

        <!-- <Accordion -->
        <div class="w-6 w-12-m w-12-s">

            @for (item of component.accordion_items; track $index; let index = $index) {
            <div class="p-t-1 m-b-5 b-b p-b-2 b-col-42 flex flex-column"
                 *abIf="item.abIfExp">
                <!-- Accordion tabs -->
                <div class="flex flex-justify-between flex-middle cursor-pointer"
                     [zippyToggle]="['faq_tab' + uid, index]">
                    <span class="w-12 w-10-m w-9-s"
                          sizeClass="XL:h2, SM:h3"
                          *iCms="'title' of item; content: 'html'"></span>
                    @if (item.title) {
                    <i class="icon-plus fs-8 fs-9-m fs-9-s col-42"
                       zippyClass="!icon-plus icon-minus"
                       [zippyName]="['faq_tab' + uid, index]"></i>
                    }
                </div>
                <!-- Accordion content -->
                <div class="ng-hide-animate p-b-6"
                     [zippyHideUp]="['faq_tab' + uid, index]"
                     zippyAnimationDuration="750">
                    <h5 class="o1 w-10 ng-hide-animate hide-up p-t-10"
                        *iCms="'description' of item; content: 'html'"></h5>
                </div>
            </div>
            }

            <!-- different question -->
            <href [link]="component?.different_question_url">
                <div class="p-t p-b-10 p-b-0-m p-b-0-s"
                     [sizeClass]="'XL: p1, SM:o1'"
                     *iCms="'different_question' of component; content: 'html'"></div>
            </href>
        </div>
    </div>
</div>